import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AudioPlayerService } from '../services/audio-player.service';
import { GameService } from '../services/game.service';

@Injectable()
export class GameGuard implements CanActivate, CanActivateChild {
    constructor(public game: GameService, public router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        const levelId = +route.parent?.params['id'];
        const gameId = +route.params['id'];

        // Redirect illegal game id's to dashboard
        if (gameId < 1 || gameId > 8) {
            this.router.navigate(['/dashboard']);
            return false;
        }

        const allowed = this.game.getGameOpenStatus(levelId, gameId);

        if (!allowed) {
            console.error('Level mag nog niet geopend worden!', levelId, gameId);
        }
        return allowed;
    }


    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }
}
